module.exports = __webpack_public_path__ + "static/media/advanced-settings.308e0643.svg";